import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

/**
 * 新任务预选项目ID原子
 * 用于在拖放FAB到项目区域时传递项目ID
 */
export const newTaskProjectIdAtom = atom<string | undefined>(undefined);

/**
 * FAB拖拽状态原子
 * 用于同步 DraggableTaskButton 和 TaskDndContext 的拖拽状态
 */
export const isTaskFabDraggingAtom = atom(false);

/**
 * 任务项拖拽状态原子
 * 用于跟踪任务项的拖拽状态
 */
export const isTaskItemDraggingAtom = atom(false);

/**
 * 拖拽中的任务ID原子
 * 用于存储正在拖拽的任务ID
 */
export const draggedTaskIdAtom = atom<string | null>(null);

/**
 * 项目拖拽状态原子
 * 用于跟踪项目的拖拽状态
 */
export const isProjectDraggingAtom = atom(false);

/**
 * 拖拽中的项目ID原子
 * 用于存储正在拖拽的项目ID
 */
export const draggedProjectIdAtom = atom<string | null>(null);

/**
 * 视图模式类型
 */
export type TaskViewMode = 'category' | 'time' | 'project';

/**
 * 使用atomWithStorage持久化存储视图模式
 * 在切换标签页后返回时保持用户选择的视图模式
 * 默认使用时间视图，提供更好的时间管理体验
 */
export const taskViewModeAtom = atomWithStorage<TaskViewMode>('v3_taskViewMode', 'time');

/**
 * 使用atomWithStorage持久化存储显示已完成任务的状态
 * 在切换标签页后返回时保持用户选择的显示/隐藏已完成任务状态
 */
export const showCompletedTasksAtom = atomWithStorage<boolean>('v3_showCompletedTasks', false);

/**
 * 全局任务编辑状态原子
 * 用于处理来自超链接的任务编辑请求
 */
export interface GlobalTaskEditState {
  taskId: string | null;
  isOpen: boolean;
  triggerSource: 'hyperlink' | 'normal';
}

export const globalTaskEditAtom = atom<GlobalTaskEditState>({
  taskId: null,
  isOpen: false,
  triggerSource: 'normal'
});
